/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Dra for å endre størrelsen på panelet',
  command_intelligence_close_aria: 'Lukk assistent',
  command_intelligence_send_aria: 'Send melding',
  command_intelligence_stop_aria: 'Stopp svar',
  command_intelligence_composer_input_aria: 'Melding til Command Intelligence',
  command_intelligence_drawer_more_options: 'Flere alternativer',
  command_intelligence_dock_position: 'Dokkingsposisjon',
  command_intelligence_dock_left: 'Venstre',
  command_intelligence_dock_right: 'Høyre',
  command_intelligence_dock_top: 'Topp',
  command_intelligence_dock_bottom: 'Bunn',
  command_intelligence_panel_layout: 'Paneloppsett',
  command_intelligence_panel_layout_overlap: 'Overlapp innhold',
  command_intelligence_panel_layout_push: 'Skyv innhold',
  command_intelligence_panel_auto_hide_overlap: 'Skjul automatisk ved klikk utenfor',
  command_intelligence_session_reset: 'Tilbakestill samtale',
  command_intelligence_try_one_of_these: 'Prøv en av disse',
  command_intelligence_attach_hint: 'Legg ved kontekstelementer for å begynne å stille spørsmål.',
  command_intelligence_attach_modal_title: 'Legg ved kontekst',
  command_intelligence_attach_modal_subtitle:
    'Velg fra elementer i denne visningen. Allerede vedlagte elementer er nedtonet.',
  command_intelligence_attach_modal_search_placeholder: 'Søk…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# element tilgjengelig} other {# elementer tilgjengelige}} · {selected} valgt',
  command_intelligence_attach_modal_empty: 'Ingenting tilgjengelig å legge ved',
  command_intelligence_attach_modal_no_results: 'Ingen elementer samsvarer med søket ditt',
  command_intelligence_context_bar_attached_section: 'Vedlagt ({count})',
  command_intelligence_context_bar_clear_attached: 'Tøm',
  command_intelligence_context_bar_add: 'Legg ved kontekst',
  command_intelligence_placeholder_ready: 'Still et spørsmål…',
  command_intelligence_placeholder_attach: 'Legg ved kontekst for å stille et spørsmål…',
  command_intelligence_composer_submit_hint: 'Enter for å sende · Shift+Enter for ny linje',
  command_intelligence_composer_stop_hint: 'Stopp · utkast til neste melding mens du venter',
  command_intelligence_response_stopped: 'Svar stoppet',
  command_intelligence_generation_in_progress: 'Jobber med spørsmålet ditt',
  command_intelligence_generation_trace_title: 'Utførte trinn',
  command_intelligence_generation_trace_toggle: 'Vis trinn',
  command_intelligence_generation_trace_summary: '{completed} av {total} trinn fullført',
  command_intelligence_generation_trace_summary_generic: 'Genereringstrinn',
  command_intelligence_generation_tool_count: '{count, plural, one {# verktøy} other {# verktøy}}',
  command_intelligence_generation_turn_label: 'Runde {turn} av {total}',
  command_intelligence_generation_turn_completed: 'Runde {turn} av {total} fullført',
  command_intelligence_generation_turn_completed_elapsed: 'Runde {turn} av {total} fullført ({seconds}s forløpt)',
  command_intelligence_generation_turn_completed_with_tools: 'Runde {turn} av {total} fullført – brukte {tools}',
  command_intelligence_generation_tools_used: 'Brukte {tools}',
  command_intelligence_reasoning_thinking: 'Tenker…',
  command_intelligence_reasoning_thought_for_seconds: 'Tenkte i {seconds} sekunder',
  command_intelligence_reasoning_waiting: 'Jobber med spørsmålet ditt…',
  command_intelligence_attach_modal_done: 'Ferdig',
  command_intelligence_attach_modal_attached_badge: 'vedlagt',
  command_intelligence_attach_modal_attach: 'Legg ved',
  command_intelligence_attach_modal_attach_count: 'Legg ved ({count})',
  command_intelligence_attach_modal_close_aria: 'Lukk velger',
  command_intelligence_session_limit_context: 'Kontekstgrense nådd. Tilbakestill samtalen for å fortsette.',
  command_intelligence_session_limit_prompt: 'Meldingsgrense nådd. Tilbakestill samtalen for å fortsette.',
  command_intelligence_suggested_followups: 'Foreslåtte oppfølginger',
  command_intelligence_credit_warning_line: '{pct}% av månedlige AI-kreditter for {scope} brukt',
  command_intelligence_tooltip_prompts: '{count} av {max} meldinger ({pct}%)',
  command_intelligence_tooltip_context: '{used} av {max} konteksttokens ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Kontekstbruk vises etter første svar',
  command_intelligence_credits_loading: 'Laster kreditter…',
  command_intelligence_credits_unavailable: 'Kreditter utilgjengelige',
  command_intelligence_credits_tooltip: 'Månedlige AI-kreditter for {monthKey}',
  command_intelligence_credits_tooltip_short: 'Månedlige AI-kreditter',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Enhet',
  command_intelligence_credits_used_of_cap: '{used} av {cap} kreditter',
  command_intelligence_credits_used_no_cap: '{used} kreditter brukt',
  command_intelligence_credits_monthly_title: 'Månedlige AI-kreditter',
  command_intelligence_compare_aria: 'Sammenlign agenter',
  command_intelligence_compare_tooltip: 'Kjør samme spørsmål mot flere agentprofiler',
  command_intelligence_compare_cancelled: 'Sammenligning avbrutt',
  command_intelligence_compare_branch_failed: 'Sammenligningsgren mislyktes',
  command_intelligence_compare_title: 'Agentsammenligning',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} inn / {outTok} ut · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Godt svar',
  command_intelligence_feedback_bad_response: 'Dårlig svar',
  command_intelligence_feedback_dialog_title: 'Gi tilbakemelding',
  command_intelligence_feedback_dialog_body:
    'Hjelp oss å forbedre oss ved å gi tilbakemelding på dette svaret. Tilbakemeldingen sendes til driftsteamet vårt.',
  command_intelligence_feedback_response_label: 'Svar',
  command_intelligence_feedback_input_label: 'Din tilbakemelding (valgfritt)',
  command_intelligence_feedback_input_placeholder: 'Hva var galt eller lite nyttig med dette svaret?',
  command_intelligence_feedback_submit: 'Send tilbakemelding',
  command_intelligence_feedback_submit_error: 'Kunne ikke sende tilbakemelding. Prøv igjen.',
  command_intelligence_feedback_question_understanding: 'Forsto agenten hva du ønsket?',
  command_intelligence_feedback_question_readability: 'Var svaret lett å lese og bruke?',
  command_intelligence_feedback_section_understanding: 'Forståelse',
  command_intelligence_feedback_section_readability: 'Lesbarhet',
  command_intelligence_feedback_choice_none: 'Ingen',
  command_intelligence_feedback_choice_misunderstood_task: 'Misforsto oppgave',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignorerte begrensning',
  command_intelligence_feedback_choice_wrong_scope: 'Feil omfang',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuelt vanskelig å lese',
  command_intelligence_feedback_choice_wrote_too_much: 'Skrev for mye',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Forklaring ikke pålitelig',
  command_intelligence_copy_aria: 'Kopier til utklippstavle',
  command_intelligence_error_missing_invoke_permission:
    'Du har ikke tillatelse til å bruke Command Intelligence for denne agenten. Be administratoren om å gi nødvendige Intelligence-tillatelser (for eksempel analyst).',
  command_intelligence_access_denied_title: 'Tilgang kreves',
  command_intelligence_error_session_expired: 'Økten din har utløpt. Oppdater siden og logg inn på nytt.',
};
